"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeCurrency = normalizeCurrency;
/**
 * Canonical ISO 4217 code for a currency the way it shows up on Romanian
 * documents, exports and bank statements — which routinely print "LEI" (or
 * "lei"/"leu") for the leu instead of its ISO code, RON. Every EXPENSE
 * ingestion boundary (AI extraction, SmartBill/Raiffeisen parsers, the
 * expense create/update schema and the stored code re-read on update) runs
 * through this so "RON" is the only spelling that ever reaches the BNR rate
 * lookup: BNR never publishes a rate for its own currency, so a stray "LEI"
 * used to fail with BNR_RATE_UNAVAILABLE. (Firm/bank-account/product
 * currency fields are storage-only and deliberately keep their own rules.)
 *
 * Anything else is only trimmed and upper-cased — an unknown value is left
 * for the caller's validation to reject, never guessed.
 */
const RON_ALIASES = new Set(['RON', 'LEI', 'LEU']);
function normalizeCurrency(raw) {
    const code = raw.trim().toUpperCase();
    return RON_ALIASES.has(code) ? 'RON' : code;
}
